import React, { useState, useEffect } from 'react';
import { FiCheckCircle, FiXCircle, FiEye, FiChevronDown, FiChevronUp, FiFilter, FiDownload, FiEdit } from 'react-icons/fi';
import './payroll-summary.css';
import { useParams } from "react-router-dom";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../Constants";
import ability from '../../config/defineAbility';
import { helpers } from '../../../helpers';
import cogoToast from "cogo-toast";
import { IconCancel, IconEyeDollar, IconMinus, IconPlus, IconUser, IconX, IconCheck } from '@tabler/icons-react'; // Optional icons
import { Loader } from 'react-overlay-loader';
 



  

import { PERMS } from '../../config/perms'
const PayrollSummary = (match) => {
  const incomingParams = useParams(); // { id: "koko" }
  var track_id = null;
  const [isLoading, setIsLoading] = useState(false);
  const [remarks, setRemarks] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [selectedTrack, setSelectedTrack] = useState(null);
  // const [incomingParams, setincomingParams] =useState(match);
  const [payrollData, setPayrollData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [expandedRow, setExpandedRow] = useState(null);
  const [departments, setDepartments] = useState([]);

  const [filters, setFilters] = useState({
    department: 'all',
    status: 'all'
  });
  const [commentText, setCommentText] = useState('');
  const [comments, setComments] = useState([]);
  const [approvalWorkflow, setApprovalWorkflow] = useState([
    { id: 1, level: 1, approver: "John Doe", comment: "", approved: null },
    { id: 2, level: 2, approver: "Jane Smith", comment: "", approved: null },
  ]);
  
  // Track selection modal states
  const [showTrackModal, setShowTrackModal] = useState(false);
  const [tracksList, setTracksList] = useState([]);
  const [loadingTracks, setLoadingTracks] = useState(false);

  // Edit payroll modal states
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingPayrollItem, setEditingPayrollItem] = useState(null);
  const [editedPayrollData, setEditedPayrollData] = useState(null);
  const [isRecalculating, setIsRecalculating] = useState(false);
  const [updatedDetailsJson, setUpdatedDetailsJson] = useState(null);
  const [showUpdatedJson, setShowUpdatedJson] = useState(false);

  // Sample data - in a real app this would come from an API
  useEffect(() => {

if(incomingParams['id']!=null)
{
  track_id = incomingParams['id'];
  getTrackDetails();
}
else
{
  showTrackSelectionModel()
}


  
  }, []);

const showTrackSelectionModel = () => {
  setShowTrackModal(true);
  fetchTracksList();
}

// Fetch tracks list from API
const fetchTracksList = () => {
  setLoadingTracks(true);
  genericGet(ENDPOINTS.LIST_COMPLETE_PAYROLL_TRACK)
    .then((res) => {
      setLoadingTracks(false);
      if (res.status === 200) {
        if (res.data.status === SUCCESS_RESULT) {
          setTracksList(res.data.data || []);
        } else {
          cogoToast.error(res.data.message || 'Failed to fetch tracks');
        }
      } else {
        cogoToast.error('Failed to fetch tracks');
      }
    })
    .catch((err) => {
      setLoadingTracks(false);
      console.error('Error fetching tracks:', err);
      cogoToast.error('Error fetching tracks');
    });
}

// Handle track selection
const handleTrackSelection = (selectedTrack) => {
  setSelectedTrack(selectedTrack);
  track_id = selectedTrack.id;
  setShowTrackModal(false);
  getTrackDetails();
}

  const getTrackDetails = () => {
    setIsLoading(true);
     

    // alert((JSON.stringify(incomingParams['id'])));
    genericPost(ENDPOINTS.TRACK_PAYROLL_APPROVAL_DETAILS, { "track_id": track_id })
      .then((res) => {

        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
            // alert((JSON.stringify(responseData)));
            setPayrollData(responseData);
            setFilteredData(responseData);
            if (responseData && responseData.length > 0) {
              const uniqueDepartments = [
                ...new Set(responseData.map(item => item.department))
              ];
              setDepartments(uniqueDepartments);
            }
            //  setFilteredData(responseData);
            // setRowData(responseData);
          } else {
            cogoToast.error(res.data.message, {});
          }
        } else {
          alert(res.status)
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
    setIsLoading(false);
  }
  // Filter data based on department and status
  useEffect(() => {
    let result = payrollData;

    if (filters.department !== 'all') {
      result = result.filter(item => item.department === filters.department);
    }

    if (filters.status !== 'all') {
      result = result.filter(item => item.payroll_status === filters.payroll_status);
    }

    setFilteredData(result);

    // Update select all state when filtering
    const allSelected = result.length > 0 && result.every(emp => selectedEmployees.includes(emp.staff_code));
    setSelectAll(allSelected);
  }, [filters, payrollData, selectedEmployees]);

  // Handle select all checkbox
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = filteredData.map(emp => emp.staff_code);
      setSelectedEmployees(allIds);
      setSelectAll(true);
    } else {
      setSelectedEmployees([]);
      setSelectAll(false);
    }
  };

  // Handle individual employee checkbox
  const handleEmployeeSelect = (id) => {
    if (selectedEmployees.includes(id)) {
      setSelectedEmployees(selectedEmployees.filter(empId => empId !== id));
      setSelectAll(false);
    } else {
      setSelectedEmployees([...selectedEmployees, id]);

      // If all employees are now selected, update selectAll
      if (selectedEmployees.length + 1 === filteredData.length) {
        setSelectAll(true);
      }
    }
  };

  // Sort data
  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });

    setFilteredData(sortedData);
    setSortConfig({ key, direction });
  };

  // Handle approval action
  const handleApproval = (id, approved) => {
    const updatedData = payrollData.map(item => {
      if (item.id === id) {
        // Find the current user's role (in a real app, this would come from authentication)
        const currentRole = 'Finance'; // Example role

        const updatedWorkflow = item.approvalWorkflow.map(step => {
          if (step.role_name === currentRole) {
            return {
              ...step,
              approved,
              date: new Date().toISOString().split('T')[0],
              comment: commentText
            };
          }
          return step;
        });

        // Determine overall status based on approvals
        const allApproved = updatedWorkflow.every(step => step.approved === true);
        const anyRejected = updatedWorkflow.some(step => step.approved === false);

        let newStatus = item.status;
        if (allApproved) newStatus = 'approved';
        else if (anyRejected) newStatus = 'rejected';
        else newStatus = 'pending';

        return {
          ...item,
          approvalWorkflow: updatedWorkflow,
          status: newStatus
        };
      }
      return item;
    });

    setPayrollData(updatedData);
    setCommentText('');
  };

  // Toggle row expansion for details
  const toggleExpand = (id) => {
    if (expandedRow === id) {
      setExpandedRow(null);
    } else {
      setExpandedRow(id);
    }
  };

  // Get status badge class
  const getStatusClass = (status) => {
    switch (status) {
      case 'approved': return 'status-badge approved';
      case 'rejected': return 'status-badge rejected';
      default: return 'status-badge pending';
    }
  };

  // Calculate percentage change from last month
  const calculateChange = (current, previous) => {
    if (previous === 0) return 0;
    return ((current - previous) / previous * 100).toFixed(1);
  };
  const handleApprovalAction = (action) => {
    setConfirmAction(action);
    setShowConfirmModal(true);
  };


  const confirmApprovalAction = () => {
    setIsLoading(true);
    let postData = {
      "track_id": selectedTrack?.id,
      "action": confirmAction,
      "remarks": remarks,
      "assignment_id":"",
      comments: comments,
    }

      genericPost(ENDPOINTS.TRACK_PAYROLL_APPROVAL, postData)
        .then((res) => {
          setIsLoading(false);
          if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
              let responseData = res.data.data;
              // alert((JSON.stringify(responseData)));
              setPayrollData(responseData);
              if (responseData && responseData.length > 0) {
                const uniqueDepartments = [
                  ...new Set(responseData.map(item => item.department))
                ];
                setDepartments(uniqueDepartments);
              }
              //  setFilteredData(responseData);
              // setRowData(responseData);
            } else {
              cogoToast.error(res.data.message, {});
            }
          } else {
            alert(res.status)
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
  };

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
    setConfirmAction(null);
  };
  const handleCommentChange = (index, value) => {
    const updated = [...approvalWorkflow];
    updated[index].comment = value;
    setApprovalWorkflow(updated);
  };

  const handleAddComment = (staff_id) => {
    if (commentText.trim()) {
      const newComment = {
        id: staff_id,
        staff_id: staff_id,
        comment: commentText.trim(),
        timestamp: new Date().toLocaleString()
      };
      setComments([...comments, newComment]);
      setCommentText('');
    }
  };

  const handleDeleteComment = (commentId) => {
    setComments(comments.filter(comment => comment.id !== commentId));
  };

  // Helper: safely normalize adjusted earnings structure to an array
  const getAdjustedEarningArray = (earnings) => {
    if (!earnings || earnings.adjusted_earning == null) return [];

    const adjusted = earnings.adjusted_earning;

    // Case 1: already an array
    if (Array.isArray(adjusted)) {
      return adjusted;
    }

    // Case 2: wrapped object like { adjusted_earning: [...], total_adjusted_earning: ... }
    if (adjusted && Array.isArray(adjusted.adjusted_earning)) {
      return adjusted.adjusted_earning;
    }

    // Fallback: not a recognizable structure
    return [];
  };

  // Calculate net pay: Earnings - Deductions
  const calculateNetPay = (data) => {
    // Calculate total earnings from components
    const basicSalary = parseFloat(data.earnings?.basic_salary || 0);
    const totalAllowances = parseFloat(data.earnings?.allowances?.total_allowances || 0);
    const totalRetirementBenefits = parseFloat(data.earnings?.retirement_benefits?.total_retirement_benefits || 0);
    const totalAdjustedEarnings = getAdjustedEarningArray(data.earnings).reduce(
      (sum, e) => sum + (parseFloat(e.amount) || 0),
      0
    );
    
    // Calculate total earnings: use gross_salary if it's been explicitly set and is non-zero,
    // otherwise calculate from components
    const calculatedEarnings = basicSalary + totalAllowances + totalRetirementBenefits + totalAdjustedEarnings;
    const grossSalary = parseFloat(data.earnings?.gross_salary || 0);
    // Use gross_salary only if it's different from calculated (meaning user manually set it)
    // Otherwise use calculated value
    const totalEarnings = (grossSalary > 0 && Math.abs(grossSalary - calculatedEarnings) > 0.01) 
      ? grossSalary 
      : calculatedEarnings;
    
    // Calculate total deductions
    const totalTaxes = parseFloat(data.deductions?.taxes?.total_taxes || 0);
    const totalOtherDeductions = parseFloat(data.deductions?.other_deductions?.total_other_deductions || 0);
    const totalAdjustedDeductions = parseFloat(data.deductions?.adjusted_deduction?.total_adjusted_deduction || 0);
    
    const totalDeductions = totalTaxes + totalOtherDeductions + totalAdjustedDeductions;
    
    // Net Pay = Earnings - Deductions
    const netPay = totalEarnings - totalDeductions;
    
    return {
      totalEarnings,
      totalDeductions,
      netPay: Math.max(0, netPay) // Ensure net pay is not negative
    };
  };

  // Handle edit payroll - now accepts employee parameter
  const handleEditPayroll = (employee) => {
    if (!employee) {
      cogoToast.error("No employee data available to edit", {});
      return;
    }

    // Check if data has details object or is already structured
    let detailsData = null;
    
    if (employee.details) {
      // If details object exists, use it
      detailsData = JSON.parse(JSON.stringify(employee.details));
      setEditingPayrollItem(employee);
    } else {
      // If details are flattened, construct the details object from the item
      // This handles the case where the API returns flattened data
      detailsData = {
        net_pay: employee.net_pay || 0,
        sources: employee.sources || [],
        earnings: {
          bonuses: employee.bonuses || [],
          allowances: {
            allowances: employee.allowances || [],
            total_allowances: employee.total_allowances || 0
          },
          basic_salary: employee.basic_salary || 0,
          gross_salary: employee.gross_earnings || employee.gross_salary || 0,
          adjusted_earning: Array.isArray(employee.adjusted_earning)
            ? employee.adjusted_earning
            : (employee.adjusted_earning?.adjusted_earning || []),
          contracted_salary: employee.basic_salary || 0,
          retirement_benefits: {
            retirement_benefits: employee.benefits || [],
            total_retirement_benefits: employee.total_benefits || 0
          }
        },
        deductions: {
          taxes: {
            taxes: employee.taxes || [],
            total_taxes: employee.total_taxes || 0
          },
          other_deductions: {
            other_deductions: employee.other_deductions || [],
            total_other_deductions: employee.other_deductions_total || 0
          },
          adjusted_deduction: {
            adjusted_deduction: employee.adjusted_deduction || [],
            total_adjusted_deduction: employee.total_adjusted_deduction || 0
          },
          total_other_deductions: (employee.total_taxes || 0) + (employee.other_deductions_total || 0) + (employee.total_adjusted_deduction || 0)
        },
        staff_details: {
          id: employee.id,
          staff_code: employee.staff_code,
          staff_name: employee.staff_name,
          department: employee.department,
          office_name: employee.office_name,
          role_name: employee.role_name,
          joined_at: employee.joined_at,
          contract_end_date: employee.contract_end_date
        },
        total_sources: employee.sources ? employee.sources.reduce((sum, s) => sum + (parseFloat(s.amount) || 0), 0) : 0,
        total_staff_payroll: employee.gross_earnings || employee.gross_salary || 0
      };
      setEditingPayrollItem({ ...employee, details: detailsData });
    }
    
    // Calculate initial net pay
    const calculated = calculateNetPay(detailsData);
    detailsData.net_pay = calculated.netPay;
    detailsData.deductions.total_other_deductions = calculated.totalDeductions;
    
    setEditedPayrollData(detailsData);
    setShowEditModal(true);
  };

  // Handle field changes in edit modal
  const handleFieldChange = (section, field, value, index = null) => {
    const updated = JSON.parse(JSON.stringify(editedPayrollData));
    
    if (section === 'earnings') {
      if (field === 'basic_salary' || field === 'gross_salary' || field === 'contracted_salary') {
        updated.earnings[field] = parseFloat(value) || 0;
        // If gross_salary is changed, use it; otherwise recalculate from components
        if (field !== 'gross_salary') {
          // Recalculate gross salary from components when basic_salary or contracted_salary changes
          const basicSalary = parseFloat(updated.earnings.basic_salary || 0);
          const totalAllowances = parseFloat(updated.earnings.allowances?.total_allowances || 0);
          const totalRetirementBenefits = parseFloat(updated.earnings.retirement_benefits?.total_retirement_benefits || 0);
          const totalAdjustedEarnings = getAdjustedEarningArray(updated.earnings).reduce(
            (sum, e) => sum + (parseFloat(e.amount) || 0),
            0
          );
          // Update gross salary to be the sum of all components
          updated.earnings.gross_salary = basicSalary + totalAllowances + totalRetirementBenefits + totalAdjustedEarnings;
        }
      } else if (field.startsWith('allowance_')) {
        const allowanceIndex = parseInt(field.split('_')[1]);
        if (updated.earnings.allowances.allowances[allowanceIndex]) {
          updated.earnings.allowances.allowances[allowanceIndex].amount = parseFloat(value) || 0;
          // Recalculate total allowances
          updated.earnings.allowances.total_allowances = updated.earnings.allowances.allowances.reduce(
            (sum, a) => sum + (parseFloat(a.amount) || 0), 0
          );
          // Recalculate gross salary from components
          const basicSalary = parseFloat(updated.earnings.basic_salary || 0);
          const totalAllowances = parseFloat(updated.earnings.allowances.total_allowances || 0);
          const totalRetirementBenefits = parseFloat(updated.earnings.retirement_benefits?.total_retirement_benefits || 0);
          const totalAdjustedEarnings = getAdjustedEarningArray(updated.earnings).reduce(
            (sum, e) => sum + (parseFloat(e.amount) || 0),
            0
          );
          updated.earnings.gross_salary = basicSalary + totalAllowances + totalRetirementBenefits + totalAdjustedEarnings;
        }
      } else if (field.startsWith('retirement_')) {
        const benefitIndex = parseInt(field.split('_')[1]);
        if (updated.earnings.retirement_benefits.retirement_benefits[benefitIndex]) {
          updated.earnings.retirement_benefits.retirement_benefits[benefitIndex].amount = parseFloat(value) || 0;
          // Recalculate total retirement benefits
          updated.earnings.retirement_benefits.total_retirement_benefits = updated.earnings.retirement_benefits.retirement_benefits.reduce(
            (sum, b) => sum + (parseFloat(b.amount) || 0), 0
          );
          // Recalculate gross salary from components
          const basicSalary = parseFloat(updated.earnings.basic_salary || 0);
          const totalAllowances = parseFloat(updated.earnings.allowances?.total_allowances || 0);
          const totalRetirementBenefits = parseFloat(updated.earnings.retirement_benefits.total_retirement_benefits || 0);
          const totalAdjustedEarnings = getAdjustedEarningArray(updated.earnings).reduce(
            (sum, e) => sum + (parseFloat(e.amount) || 0),
            0
          );
          updated.earnings.gross_salary = basicSalary + totalAllowances + totalRetirementBenefits + totalAdjustedEarnings;
        }
      }
    } else if (section === 'deductions') {
      if (field.startsWith('tax_')) {
        const taxIndex = parseInt(field.split('_')[1]);
        if (updated.deductions.taxes.taxes[taxIndex]) {
          updated.deductions.taxes.taxes[taxIndex].amount = parseFloat(value) || 0;
          // Recalculate total taxes
          updated.deductions.taxes.total_taxes = updated.deductions.taxes.taxes.reduce(
            (sum, t) => sum + (parseFloat(t.amount) || 0), 0
          );
        }
      } else if (field.startsWith('other_deduction_')) {
        const deductionIndex = parseInt(field.split('_')[2]);
        if (updated.deductions.other_deductions.other_deductions[deductionIndex]) {
          updated.deductions.other_deductions.other_deductions[deductionIndex].amount = parseFloat(value) || 0;
          // Recalculate total other deductions
          updated.deductions.other_deductions.total_other_deductions = updated.deductions.other_deductions.other_deductions.reduce(
            (sum, d) => sum + (parseFloat(d.amount) || 0), 0
          );
        }
      } else if (field.startsWith('adjusted_deduction_')) {
        const adjDeductionIndex = parseInt(field.split('_')[2]);
        if (updated.deductions.adjusted_deduction.adjusted_deduction[adjDeductionIndex]) {
          updated.deductions.adjusted_deduction.adjusted_deduction[adjDeductionIndex].amount = parseFloat(value) || 0;
          // Recalculate total adjusted deduction
          updated.deductions.adjusted_deduction.total_adjusted_deduction = updated.deductions.adjusted_deduction.adjusted_deduction.reduce(
            (sum, d) => sum + (parseFloat(d.amount) || 0), 0
          );
        }
      }
    } else if (section === 'sources') {
      if (index !== null && updated.sources[index]) {
        if (field === 'amount' || field === 'percentage') {
          updated.sources[index][field] = parseFloat(value) || 0;
        } else {
          updated.sources[index][field] = value;
        }
      }
    }
    
    // Recalculate net pay whenever earnings or deductions change
    if (section === 'earnings' || section === 'deductions') {
      const calculated = calculateNetPay(updated);
      updated.net_pay = calculated.netPay;
      // Update total deductions if needed
      updated.deductions.total_other_deductions = calculated.totalDeductions;
    }
    
    // Force state update to trigger re-render
    setEditedPayrollData({ ...updated });
  };

  // Handle update payroll
  const handleUpdatePayroll = () => {
    if (!editingPayrollItem || !editedPayrollData) {
      cogoToast.error("No data to update", {});
      return;
    }

    setIsRecalculating(true);
    
    // Recalculate all totals before sending
    const calculated = calculateNetPay(editedPayrollData);
    
    // Calculate total sources
    const totalSources = (editedPayrollData.sources || []).reduce(
      (sum, s) => sum + (parseFloat(s.amount) || 0), 0
    );
    
    // Calculate total staff payroll (gross salary)
    const totalStaffPayroll = calculated.totalEarnings;
    
    // Format deductions - adjusted_deduction should be an array, not an object
    // Handle both structures: {adjusted_deduction: [...]} or just [...]
    let adjustedDeductionArray = [];
    if (Array.isArray(editedPayrollData.deductions?.adjusted_deduction)) {
      adjustedDeductionArray = editedPayrollData.deductions.adjusted_deduction;
    } else if (editedPayrollData.deductions?.adjusted_deduction?.adjusted_deduction) {
      adjustedDeductionArray = editedPayrollData.deductions.adjusted_deduction.adjusted_deduction;
    } else if (editedPayrollData.deductions?.adjusted_deduction) {
      adjustedDeductionArray = editedPayrollData.deductions.adjusted_deduction;
    }
    
    // Build the details object in the exact format required
    const detailsPayload = {
      net_pay: calculated.netPay,
      sources: editedPayrollData.sources || [],
      earnings: {
        bonuses: editedPayrollData.earnings?.bonuses || [],
        allowances: {
          allowances: editedPayrollData.earnings?.allowances?.allowances || [],
          total_allowances: editedPayrollData.earnings?.allowances?.total_allowances || 0
        },
        basic_salary: parseFloat(editedPayrollData.earnings?.basic_salary || 0),
        gross_salary: calculated.totalEarnings,
        adjusted_earning: editedPayrollData.earnings?.adjusted_earning || [],
        contracted_salary: parseFloat(editedPayrollData.earnings?.contracted_salary || editedPayrollData.earnings?.basic_salary || 0),
        retirement_benefits: {
          retirement_benefits: editedPayrollData.earnings?.retirement_benefits?.retirement_benefits || [],
          total_retirement_benefits: editedPayrollData.earnings?.retirement_benefits?.total_retirement_benefits || 0
        }
      },
      deductions: {
        taxes: {
          taxes: editedPayrollData.deductions?.taxes?.taxes || [],
          total_taxes: editedPayrollData.deductions?.taxes?.total_taxes || 0
        },
        other_deductions: {
          other_deductions: editedPayrollData.deductions?.other_deductions?.other_deductions || [],
          total_other_deductions: editedPayrollData.deductions?.other_deductions?.total_other_deductions || 0
        },
        adjusted_deduction: adjustedDeductionArray,
        total_other_deductions: calculated.totalDeductions
      },
      staff_details: editedPayrollData.staff_details || {},
      total_sources: totalSources,
      total_staff_payroll: totalStaffPayroll
    };
    
    // Prepare the data to send to API in the required format
    const payload = {
      id: editingPayrollItem.id,
      details: detailsPayload,
      amount: calculated.netPay
    };

    // Call the API to update
    const endpoint = ENDPOINTS.UPDATE_PAYROLL_TRACK_DETAILS;
    
    genericPost(endpoint, payload)
      .then((res) => {
        setIsRecalculating(false);
        if (res.status === 200) {
          if (res.data.status === SUCCESS_RESULT) {
            cogoToast.success("Payroll updated successfully", {});
            // Show the updated JSON instead of closing modal
            setUpdatedDetailsJson(JSON.stringify(detailsPayload, null, 2));
            setShowUpdatedJson(true);
            // Refresh the payroll data
            getTrackDetails();
          } else {
            cogoToast.error(res.data.message || "Failed to update payroll", {});
          }
        } else {
          cogoToast.error("Failed to update payroll", {});
        }
      })
      .catch((err) => {
        setIsRecalculating(false);
        console.error("Error updating payroll:", err);
        cogoToast.error("Something went wrong while updating payroll", {});
      });
  };
  return (
    <div className="payroll-summary-container">
      <style jsx>{`
        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: translateY(-50px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        
        .modal-overlay {
          backdrop-filter: blur(5px);
        }
        
        .modal-dialog:hover {
          transform: translateY(-2px);
          transition: transform 0.2s ease;
        }
        
        .btn:hover {
          transform: translateY(-1px);
          transition: all 0.2s ease;
        }
      `}</style>
      <div className="payroll-header">
        <h1>PAYROLL SUMMARY:- {payrollData.length > 0 ? payrollData[0].track_name : ""} </h1>
        <div className="header-actions">
          <button className="btn btn-secondary">
            <FiFilter /> Filter
          </button>
          <button className="btn btn-primary">
            <FiDownload /> Export
          </button>
        </div>
      </div>
      <center> <Loader loading={isLoading} /></center>
      <div className="filters">
        <div className="filter-group">
          <label>Department:</label>
          <select
            value={filters.department}
            onChange={(e) => setFilters({ ...filters, department: e.target.value })}
          >
            <option value="all">All Departments</option>
            {departments.map(dep => (
              <option key={dep} value={dep}>
                {dep}
              </option>
            ))}
            {/* <option value="Engineering">Engineering</option>
            <option value="Marketing">Marketing</option>
            <option value="Finance">Finance</option>
            <option value="HR">HR</option> */}
          </select>
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>

        <div style={{ alignSelf: 'flex-end', marginLeft: 60 }}>
          <label>Remarks</label>
          <table>
            <tbody>
              <tr> <td>
               
                <textarea
                  className="form-control comment-box"
                  rows="2"
                  cols="50"
                  value={remarks}
                  onChange={(e) =>
                    setRemarks(e.target.value)
                  }
                  placeholder="Add overall comment..."
                />
              </td>
                <td>
                  <div className="d-flex justify-content-end">
                    &nbsp; <button
                      className="btn btn-success"
                      onClick={() => handleApprovalAction( "10001")}
                    >
                      Approve Payroll
                    </button>&nbsp;&nbsp;
                    <button
                      className="btn btn-danger ml-2"
                      onClick={() => handleApprovalAction("10002")}
                    >
                      Reject Payroll
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


      <div className="payroll-table-container">
        {/* {JSON.stringify(payrollData)} */}
        <table className="payroll-table">
          <thead>
            <tr>
              <th className="checkbox-column">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  title="Select all employees"
                />
              </th>
              <th className="counter-column">#</th>
              <th>Staff</th>
              {/* <th onClick={() => handleSort('staff_code')}>Staff ID</th> */}
              <th onClick={() => handleSort('department')}>Department</th>
              <th onClick={() => handleSort('office_name')}>Branch</th>
              <th>Salary</th>
              <th>Allowc & Bonus</th>
              {/* <th>Bonus</th> */}
              {/* <th>Adj.Earnings</th> */}
              <th>Taxes</th>
              {/* <th>Adj.Deductions</th> */}
              <th onClick={() => handleSort('net_pay')}>Net Pay</th>
              <th>Last Month</th>
              <th>Change</th>
              <th onClick={() => handleSort('payroll_status')}>Status</th>
              <th>Edit</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((employee, index) => (
              <React.Fragment key={employee?.id ?? index}>
                <tr className={expandedRow === employee?.id ? "expanded" : ""}>
                  <td className="checkbox-column">
                    <input
                      type="checkbox"
                      checked={selectedEmployees.includes(employee?.id ?? "")}
                      onChange={() => handleEmployeeSelect(employee?.id ?? "")}
                    />
                  </td>

                  <td className="counter-column">{index + 1}</td>
                  <td className="employee-info">
                    <div className="employee-name">{employee.staff_name}</div>
                    <div className="employee-id">{employee.staff_code} | {employee.role_name}</div>
                  </td>
                  {/* <td>{employee?.staff_name ?? ""}</td>
                  <td>{employee?.staff_code ?? ""}</td> */}
                  {/* <td className="employee-info">
                    <div className="employee-name">{employee?.staff_name ?? ""}</div>
                  </td> */}
                  {/* <td className="employee-info">
                    <div className="employee-id">
                      {(employee?.staff_code ?? "")} */}
                  {/* | {(employee?.position ?? "")} */}
                  {/* </div>
                  </td> */}
                  <td>{employee?.department ?? ""}</td>
                  <td>{employee?.office_name ?? ""}</td>
                  <td>${employee?.basic_salary ?? ""}</td>
                  <td>${(employee?.total_allowances ?? 0) + (employee?.total_bonus ?? 0)}</td>
                  {/* <td>${employee?.total_bonus ?? ""}</td> */}
                  {/* <td>${employee?.total_adjusted_earning ?? ""}</td> */}
                  <td>${employee?.total_taxes ?? ""}</td>
                  {/* <td>${employee?.total_adjusted_deduction ?? ""}</td> */}
                  <td>${employee?.net_pay ?? ""}</td>
                  <td>${employee?.last_month_pay ?? "0.00"}</td>
                  <td>{employee?.percentage_change ?? "0%"}</td>
                  <td>{employee?.approval_status ?? "Pending"}</td>
                  <td>
                    <button
                      className="btn btn-warning btn-sm"
                      onClick={() => handleEditPayroll(employee)}
                      disabled={isRecalculating}
                      style={{ 
                        padding: '4px 8px',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}
                      title="Edit & Recalculate Payroll"
                    >
                      <FiEdit size={14} /> Edit
                    </button>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-icon"
                        onClick={() => toggleExpand(employee?.id ?? "")}
                      >
                        <span style={{ fontSize: 20, color: "black" }}>  {expandedRow === employee?.id ? <FiChevronUp /> : <FiChevronDown />}</span>
                      </button>
                      {/* <button className="btn-icon">
                        <FiEye />
                      </button> */}
                    </div>
                  </td>
                </tr>

                {expandedRow === employee?.id && (
                  <tr className="details-row">
                    <td colSpan="14">
                      <div className="col-md-12 payroll-summary">
                        <div className="table-responsive payroll-table-container">
                          <table className="table table-striped table-hover table-bordered payroll-table" style={{ outline: 2, borderColor: "000000" }}>
                            <thead>
                              <tr>
                                <th colSpan={8} className="section-header bg-primary text-white">
                                  <IconUser size={20} className="mr-1" />
                                  Employee Profile
                                </th>
                              </tr>
                              <tr>
                                <th>Staff ID</th>
                                <th>Staff Name</th>
                                <th>Role</th>
                                <th>Department</th>
                                <th>Office</th>
                                <th>Joined At</th>
                                <th>End Date</th>
                                <th>Net Pay</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>{employee?.staff_code ?? ""}</td>
                                <td>{employee?.staff_name ?? ""}</td>
                                <td>{employee?.role_name ?? ""}</td>
                                <td>{employee?.department ?? ""}</td>
                                <td>{employee?.office_name ?? ""}</td>
                                <td>{employee?.joined_at ?? ""}</td>
                                <td>{employee?.contract_end_date ?? ""}</td>
                                <td className="text-success fw-bold">
                                  ${employee?.net_pay ?? 0}
                                </td>
                              </tr>

                              {/* Earnings Section */}
                              <tr>
                                <td colSpan={4} className="p-0">
                                  <table className="table table-sm inner-table">
                                    <thead>
                                      <tr>
                                        <th colSpan={2} className="section-header bg-success text-white">
                                          <IconPlus size={18} className="mr-1" /> Earnings
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Contracted Salary</td>
                                        <td>${employee?.basic_salary ?? 0}</td>
                                      </tr>

                                      {(employee?.allowances ?? []).length > 0 && (
                                        <tr><td colSpan={2}>
                                          <table>
                                            <thead><tr><th colSpan={6} className="text-success" style={{ fontSize: 10 }} >ALLOWANCES</th></tr></thead>
                                            <tbody>
                                              {(employee?.allowances ?? []).map((a, i) => (
                                                <tr key={i}>
                                                  <td> <IconCheck size={18} /> {a?.name ?? ""}</td>

                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td>${a?.amount ?? 0}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </td>
                                        </tr>
                                      )}
                                      <tr className="fw-bold text-primary">
                                        <td>Total Allowances</td>
                                        <td>${employee?.total_allowances ?? 0}</td>
                                      </tr>
                                      <tr className="fw-bold text-success">
                                        <td>Gross Salary</td>
                                        <td><u>${employee?.gross_earnings ?? 0}</u></td>
                                      </tr>
                                      {/* <tr>
                                        <td className="section-subtitle text-primary"><b><u>ADJUSTED EARNINGS</u></b></td>
                                        <td>
                                        </td>
                                      </tr> */}
                                      {(employee?.adjusted_earning ?? []).length > 0 && (
                                        <tr><td colSpan={2}>
                                          <table>
                                            <thead><tr><th colSpan={6} className="text-success" style={{ fontSize: 10 }} >ADJUSTED EARNINGS</th></tr></thead>
                                            <tbody>
                                              {(employee?.adjusted_earning ?? []).map((a, i) => (
                                                <tr key={i}>
                                                  <td> <IconCheck size={18} /> {a?.name ?? ""}</td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td>${a?.amount ?? 0}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </td>
                                        </tr>
                                      )}


                                      <tr className="fw-bold text-primary">
                                        <td>Total Adjusted Earnings</td>
                                        <td>
                                          ${employee?.total_adjusted_earning}
                                        </td>
                                      </tr>
                                      {/* <tr className="section-subtitle">
                                        <td colSpan={2}>Benefits</td>
                                      </tr>
                                      {(employee?.benefits ?? []).map(
                                        (a, i) => (
                                          <tr key={i}>
                                            <td>{a?.name ?? ""}</td>
                                            <td>${a?.amount ?? 0}</td>
                                          </tr>
                                        )
                                      )} */}
                                      {(employee?.benefits ?? []).length > 0 && (
                                        <tr>
                                          <td colSpan={2}>
                                            <table>
                                              <thead><tr><th colSpan={6} className="text-success" style={{ fontSize: 10 }} >BENEFITS</th></tr></thead>
                                              <tbody>
                                                {(employee?.benefits ?? []).map((a, i) => (
                                                  <tr key={i}>
                                                    <td> <IconCheck size={18} /> {a?.name ?? ""}</td>

                                                    <td></td>   <td></td>   <td></td>   <td></td>
                                                    <td>${a?.amount ?? 0}</td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      )}
                                      <tr className="fw-bold text-primary">
                                        <td>Total Benefits</td>
                                        <td>
                                          ${employee?.total_benefits ?? 0}
                                        </td>
                                      </tr>
                                      <tr className="fw-bold text-success border-top">
                                        <td>Total Payroll Amount</td>
                                        <td>
                                          <u style={{
                                            textDecoration: 'none',
                                            borderBottom: 'double 3px currentColor',
                                            paddingBottom: '2px'
                                          }}> ${employee?.total_earnings ?? 0}</u>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>

                                {/* Deductions Section */}
                                <td colSpan={4} className="p-0">
                                  <table className="table table-sm inner-table">
                                    <thead>
                                      <tr>
                                        <th colSpan={2} className="section-header bg-danger text-white">
                                          <IconMinus size={18} className="mr-1" /> Deductions
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {(employee?.taxes ?? []).length > 0 && (
                                        <tr><td colSpan={2}>
                                          <table>
                                            <thead><tr><th colSpan={6} className="text-danger" style={{ fontSize: 10 }} >TAXES</th></tr></thead>
                                            <tbody>
                                              {(employee?.taxes ?? []).map((a, i) => (
                                                <tr key={i}>
                                                  <td> <IconCheck size={18} /> {a?.name ?? ""}</td>

                                                  <td></td>   <td></td>   <td></td>   <td></td>
                                                  <td>${a?.amount ?? 0}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </td>
                                        </tr>
                                      )}
                                      <tr className="fw-bold text-primary">
                                        <td>Total Taxes</td>
                                        <td>${employee?.total_taxes ?? 0}</td>
                                      </tr>

                                      {(employee?.other_deductions ?? []).length > 0 && (
                                        <tr><td colSpan={2}>
                                          <table>
                                            <thead><tr><th colSpan={6} className="text-danger" style={{ fontSize: 10 }} >OTHER EXTRA DEDUCTIONS</th></tr></thead>
                                            <tbody>
                                              {(employee?.other_deductions ?? []).map((a, i) => (
                                                <tr key={i}>
                                                  <td> <IconCheck size={18} /> {a?.name ?? ""}</td>

                                                  <td></td>   <td></td>   <td></td>   <td></td>
                                                  <td>${a?.amount ?? 0}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </td>
                                        </tr>
                                      )}
                                      <tr>
                                        <td className="fw-bold ">Total Extra Deductions</td>
                                        <td>${employee?.other_deductions_total ?? 0}</td>
                                      </tr>

                                      {(employee?.adjusted_deduction ?? []).length > 0 && (
                                        <tr><td colSpan={2}>
                                          <table>
                                            <thead><tr><th colSpan={6} className="text-danger" style={{ fontSize: 10 }} >ADJUSTED DEDUCTIONS</th></tr></thead>
                                            <tbody>
                                              {(employee?.adjusted_deduction ?? []).map((a, i) => (
                                                <tr key={i}>
                                                  <td> <IconCheck size={18} /> {a?.name ?? ""}</td>

                                                  <td></td>   <td></td>   <td></td>   <td></td>
                                                  <td>${a?.amount ?? 0}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </td>
                                        </tr>
                                      )}
                                      <tr className="fw-bold text-primary">
                                        <td>Total Adjusted Deductions</td>
                                        <td>
                                          ${employee?.total_adjusted_deduction ?? 0}
                                        </td>
                                      </tr>
                                      <tr className="fw-bold text-danger border-top">
                                        <td>Total Deductions</td>
                                        <td>
                                          <u style={{
                                            textDecoration: 'none',
                                            borderBottom: 'double 3px currentColor',
                                            paddingBottom: '2px'
                                          }}> ${(employee?.total_deductions ?? 0) + (employee?.total_taxes ?? 0)}</u>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>

                              {/* Sources of Funds */}
                              <tr>
                                <td colSpan={3} className="p-0">
                                  <table className="table table-sm inner-table">
                                    <thead>
                                      <tr>
                                        <th colSpan={5} className="section-header bg-info text-white">
                                          <IconEyeDollar size={18} className="mr-1" /> Sources of Funds
                                        </th>
                                      </tr>
                                      <tr>
                                        <th>Project</th>
                                        <th>Budget</th>
                                        <th>Budget Code</th>
                                        <th>(%)</th>
                                        <th>Amount</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(employee?.sources ?? []).map((s, i) => (
                                        <tr key={s.id ?? i}>
                                          <td>{s.project_name ?? ""}</td>
                                          <td>{s.budget_name ?? ""}</td>
                                          <td>{s.budget_line ?? ""}</td>
                                          <td>{s.percentage ?? 0}%</td>
                                          <td>${s.amount ?? 0}</td>
                                        </tr>
                                      ))}
                                      <tr className="fw-bold text-primary">
                                        <td colSpan={3}>Total Sources</td>
                                        <td colSpan={3}>
                                          $
                                          {(
                                            (employee?.sources ?? []).reduce(
                                              (sum, s) => sum + parseFloat(s.amount || 0),
                                              0
                                            ) || 0
                                          ).toFixed(2)}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>

                                {/* LAST ROW TO SHOW APPROVAL WORKFLOWS AND COMMENTS AND BUTTONS APPROVE OR REJECT */}
                                <td colSpan={5} className="p-0">
                                  <table className="table table-sm inner-table">
                                    <thead>
                                      <tr>
                                        <th colSpan={5} className="section-header bg-info text-white">
                                          <IconEyeDollar size={18} className="mr-1" /> COMMENTS
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td colSpan={5}>
                                          <div className="comments-container p-3">
                                            {/* Comment Input Section */}
                                            <div className="comment-input-section mb-3">
                                              <div className="row">
                                                <div className="col-md-8">
                                                  
                                                  <textarea
                                                    className="form-control"
                                                    value={commentText}
                                                    onChange={(e) => setCommentText(e.target.value)}
                                                    placeholder="Add a comment..."
                                                    rows="3"
                                                  />
                                                </div>
                                                <div className="col-md-4 d-flex align-items-end">
                                                  <button
                                                    className="btn btn-primary me-2"
                                                    onClick={() => handleAddComment(employee.id)}
                                                    disabled={!commentText.trim()}
                                                  >
                                                    Add Comment
                                                  </button>
                                                </div>
                                              </div>
                                            </div>

 
                                            {/* Comments Display Section */}
                                            {(() => {
                                              const employeeComments = comments.filter(comment => comment.staff_id === employee.id);
                                              return employeeComments.length > 0 ? (
                                                <div className="comments-list">
                                                  <h6 className="mb-3">Comments ({employeeComments.length})</h6>
                                                  {employeeComments.map((comment) => (
                                                    <div key={comment.id} className="comment-item mb-2 p-2 border rounded">
                                                      <div className="d-flex justify-content-between align-items-start">
                                                        <div className="comment-text flex-grow-1">
                                                          {comment.comment}
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                          <small className="text-muted me-2">
                                                            {comment.timestamp}
                                                          </small>
                                                          <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => handleDeleteComment(comment.id)}
                                                            title="Delete comment"
                                                          >
                                                            ×
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ))}
                                                </div>
                                              ) : (
                                                <div className="text-center text-muted py-3">
                                                  No comments added yet.
                                                </div>
                                              );
                                            })()}
                                          </div>
                                        </td>
                                        {/* <td colSpan={2}>
                                          <div className="d-flex justify-content-end">
                                            <button
                                              className="btn btn-success"
                                              onClick={() => handleApprovalAction(employee, "10001")}
                                            >
                                              Approve
                                            </button>
                                            <button
                                              className="btn btn-danger ml-2"
                                              onClick={() => handleApprovalAction(employee, "10002")}
                                            >
                                              Reject
                                            </button>
                                          </div>
                                        </td> */}
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>

        </table>
      </div>

      <div className="payroll-footer">
        <div className="selected-count">
          {selectedEmployees.length} of {filteredData.length} employees selected
        </div>
        <div className="summary">
          <div className="summary-item">
            <span>Total Payroll:</span>
            <span>${filteredData.reduce((sum, emp) => sum + emp.net_pay ?? 0, 0).toLocaleString()}</span>
          </div>
          <div className="summary-item">
            <span>Last Month:</span>
            <span>${filteredData.reduce((sum, emp) => sum + (emp.last_month_pay ?? 0), 0).toLocaleString()}</span>
          </div>
          <div className="summary-item">
            <span>Change:</span>
            <span className={
              filteredData.reduce((sum, emp) => sum + (emp.net_pay ?? 0), 0) >
                filteredData.reduce((sum, emp) => sum + (emp.last_month_pay ?? 0), 0) ? 'positive' : 'negative'
            }>
              {calculateChange(
                filteredData.reduce((sum, emp) => sum + (emp.net_pay ?? 0), 0),
                filteredData.reduce((sum, emp) => sum + (emp.last_month_pay ?? 0), 0)
              ) ?? 0}%
            </span>
          </div>
        </div>
      </div>

      {/* Track Selection Modal */}
      {showTrackModal && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '20px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
          }}>
            <div className="modal-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
              borderBottom: '1px solid #dee2e6',
              paddingBottom: '10px'
            }}>
              <h3 style={{ margin: 0, color: '#495057' }}>Select Payroll Track</h3>
              <button
                onClick={() => setShowTrackModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#6c757d'
                }}
              >
                ×
              </button>
            </div>
            
            <div className="modal-body">
              {loadingTracks ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p style={{ marginTop: '10px' }}>Loading tracks...</p>
                </div>
              ) : tracksList.length > 0 ? (
                <div className="tracks-list">
                  {tracksList.map((track, index) => (
                    <div
                      key={track.id}
                      className="track-item"
                      onClick={() => handleTrackSelection(track)}
                      style={{
                        padding: '15px',
                        border: '1px solid #dee2e6',
                        borderRadius: '6px',
                        marginBottom: '10px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        backgroundColor: '#f8f9fa'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#e9ecef';
                        e.target.style.borderColor = '#007bff';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#f8f9fa';
                        e.target.style.borderColor = '#dee2e6';
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <h5 style={{ margin: '0 0 5px 0', color: '#495057' }}>{track.name}</h5>
                          <p style={{ margin: '0', color: '#6c757d', fontSize: '14px' }}>
                            {new Date(track.created_at).toLocaleDateString()} - Month: {track.month}, Year: {track.year}
                          </p>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <span style={{
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            backgroundColor: track.status === 10000 ? '#d4edda' : '#f8d7da',
                            color: track.status === 10000 ? '#155724' : '#721c24'
                          }}>
                            {track.status === 10000 ? 'Active' : 'Inactive'}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <p style={{ color: '#6c757d' }}>No tracks available</p>
                </div>
              )}
            </div>
            
            <div className="modal-footer" style={{
              borderTop: '1px solid #dee2e6',
              paddingTop: '15px',
              textAlign: 'right'
            }}>
              <button
                onClick={() => setShowTrackModal(false)}
                className="btn btn-secondary"
                style={{ marginRight: '10px' }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Beautiful Confirmation Modal */}
      {showConfirmModal && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div className="modal-dialog" style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            maxWidth: '500px',
            width: '90%',
            margin: '20px',
            animation: 'modalSlideIn 0.3s ease-out'
          }}>
            <div className="modal-content" style={{ border: 'none', borderRadius: '12px' }}>
              <div className="modal-header" style={{
                borderBottom: 'none',
                padding: '30px 30px 20px 30px',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  backgroundColor: confirmAction === '10001' ? '#d4edda' : '#f8d7da',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
             
                }}>
                  {confirmAction === '10001' ? (
                    <IconCheck size={40} color="#28a745" />
                  ) : (
                    <IconX size={40} color="#dc3545" />
                  )}
                </div>
             
              <h2>    {confirmAction === '10001' ? 'Approve Payroll' : 'Reject Payroll'} </h2> 
                 
                <hr/>
              
              </div>
              <p style={{
                  margin: '10px 0 0 0',
                  color: '#666',
                  display: 'block',
                  textAlign: 'center',
                  fontSize: '16px'
                }}>
                  {confirmAction === '10001' 
                    ? 'Are you sure you want to approve this payroll? This action will process all employee payments.'
                    : 'Are you sure you want to reject this payroll? This action will prevent payment processing.'
                  }
                </p>
              <div className="modal-body" style={{
                padding: '0 30px 20px 30px',
                textAlign: 'center'
              }}>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  padding: '15px',
                  margin: '15px 0',
                  border: '1px solid #e9ecef'
                }}>
                  <strong>Payroll Track:</strong> {payrollData.length > 0 ? payrollData[0].track_name : 'N/A'}
                </div>
                
                {remarks && (
                  <div style={{
                    backgroundColor: '#e3f2fd',
                    borderRadius: '8px',
                    padding: '15px',
                    margin: '15px 0',
                    border: '1px solid #bbdefb'
                  }}>
                    <strong>Remarks:</strong> {remarks}
                  </div>
                )}
                
                {comments.length > 0 && (
                  <div style={{
                    backgroundColor: '#fff3cd',
                    borderRadius: '8px',
                    padding: '15px',
                    margin: '15px 0',
                    border: '1px solid #ffeaa7'
                  }}>
                    <strong>Comments:</strong> {comments.length} comment(s) added
                  </div>
                )}
              </div>
              
              <div className="modal-footer" style={{
                borderTop: '1px solid #e9ecef',
                padding: '20px 30px 30px 30px',
                display: 'flex',
                justifyContent: 'center',
                gap: '15px'
              }}>
                <button
                  onClick={closeConfirmModal}
                  className="btn btn-secondary"
                  style={{
                    padding: '12px 30px',
                    borderRadius: '8px',
                    fontWeight: '500',
                    fontSize: '16px',
                    border: '2px solid #6c757d',
                    backgroundColor: 'transparent',
                    color: '#6c757d'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={confirmApprovalAction}
                  className={`btn ${confirmAction === '10001' ? 'btn-success' : 'btn-danger'}`}
                  style={{
                    padding: '12px 30px',
                    borderRadius: '8px',
                    fontWeight: '500',
                    fontSize: '16px',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}
                >
                  {confirmAction === '10001' ? '✓ Approve Payroll' : '✗ Reject Payroll'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Payroll Modal */}
      {showEditModal && editedPayrollData && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          zIndex: 9999,
          overflow: 'auto',
          padding: '20px 20px 20px 20px'
        }}>
          <div className="modal-dialog" style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            maxWidth: '98%',
            width: '1800px',
            maxHeight: '98vh',
            height: '98vh',
            overflow: 'auto',
            margin: '10px auto',
            animation: 'modalSlideIn 0.3s ease-out',
            marginTop: '10px'
          }}>
            <div className="modal-content" style={{ border: 'none', borderRadius: '12px' }}>
              <div className="modal-header" style={{
                borderBottom: '1px solid #e9ecef',
                padding: '20px 30px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <h2 style={{ margin: 0, color: '#495057' }}>Edit & Recalculate Payroll</h2>
                <button
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingPayrollItem(null);
                    setEditedPayrollData(null);
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '24px',
                    cursor: 'pointer',
                    color: '#6c757d'
                  }}
                >
                  ×
                </button>
              </div>

              <div className="modal-body" style={{
                padding: '20px',
                maxHeight: 'calc(98vh - 180px)',
                overflow: 'auto'
              }}>
                {editedPayrollData && (
                  <div>
                    {/* Staff Details Section */}
                    <div className="mb-3" style={{
                      backgroundColor: '#f8f9fa',
                      padding: '12px',
                      borderRadius: '6px',
                      marginBottom: '15px'
                    }}>
                      <h5 style={{ color: '#495057', marginBottom: '10px', fontSize: '16px' }}>Staff Details</h5>
                      <div className="row">
                        <div className="col-md-3">
                          <small className="text-muted d-block">Name</small>
                          <strong>{editingPayrollItem?.details?.staff_details?.staff_name || 'N/A'}</strong>
                        </div>
                        <div className="col-md-2">
                          <small className="text-muted d-block">Code</small>
                          <strong>{editingPayrollItem?.details?.staff_details?.staff_code || 'N/A'}</strong>
                        </div>
                        <div className="col-md-2">
                          <small className="text-muted d-block">Department</small>
                          <strong>{editingPayrollItem?.details?.staff_details?.department || 'N/A'}</strong>
                        </div>
                        <div className="col-md-5">
                          <small className="text-muted d-block">Net Pay (Auto-calculated)</small>
                          <span className="text-success fw-bold" style={{ fontSize: '18px' }}>
                            ${(() => {
                              const calculated = calculateNetPay(editedPayrollData);
                              return calculated.netPay.toFixed(2);
                            })()}
                          </span>
                          <small className="text-muted d-block" style={{ fontSize: '11px', marginTop: '2px' }}>
                            {(() => {
                              const calculated = calculateNetPay(editedPayrollData);
                              return `Earnings: $${calculated.totalEarnings.toFixed(2)} - Deductions: $${calculated.totalDeductions.toFixed(2)}`;
                            })()}
                          </small>
                        </div>
                      </div>
                    </div>

                    {/* Earnings and Deductions Side by Side */}
                    <div className="row mb-3" style={{ display: 'flex', flexWrap: 'nowrap', marginLeft: '0', marginRight: '0', gap: '10px' }}>
                      {/* Earnings Section */}
                      <div className="col-md-6" style={{
                        backgroundColor: '#d4edda',
                        padding: '12px',
                        borderRadius: '6px',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 50%',
                        minWidth: 0
                      }}>
                        <h5 style={{ color: '#155724', marginBottom: '12px', fontSize: '16px' }}>Earnings</h5>
                        
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group mb-2">
                              <label style={{ fontSize: '13px', marginBottom: '4px' }}><strong>Basic Salary</strong></label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={editedPayrollData.earnings?.basic_salary || 0}
                                onChange={(e) => handleFieldChange('earnings', 'basic_salary', e.target.value)}
                                step="0.01"
                                style={{ padding: '6px 10px', fontSize: '13px' }}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group mb-2">
                              <label style={{ fontSize: '13px', marginBottom: '4px' }}><strong>Contracted Salary</strong></label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={editedPayrollData.earnings?.contracted_salary || 0}
                                onChange={(e) => handleFieldChange('earnings', 'contracted_salary', e.target.value)}
                                step="0.01"
                                style={{ padding: '6px 10px', fontSize: '13px' }}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group mb-2">
                              <label style={{ fontSize: '13px', marginBottom: '4px' }}><strong>Gross Salary</strong></label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={editedPayrollData.earnings?.gross_salary || 0}
                                onChange={(e) => handleFieldChange('earnings', 'gross_salary', e.target.value)}
                                step="0.01"
                                style={{ padding: '6px 10px', fontSize: '13px' }}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Allowances */}
                        {editedPayrollData.earnings?.allowances?.allowances?.length > 0 && (
                          <div className="mb-2">
                            <label style={{ fontSize: '13px', marginBottom: '8px' }}><strong>Allowances</strong></label>
                            {editedPayrollData.earnings.allowances.allowances.map((allowance, index) => (
                              <div key={allowance.id || index} className="mb-2">
                                <div className="input-group input-group-sm">
                                  <span className="input-group-text" style={{ fontSize: '12px', padding: '4px 8px', width: 'auto', minWidth: '120px' }}>{allowance.name}</span>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={allowance.amount || 0}
                                    onChange={(e) => handleFieldChange('earnings', `allowance_${index}`, e.target.value)}
                                    step="0.01"
                                    style={{ padding: '4px 8px', fontSize: '12px' }}
                                  />
                                </div>
                              </div>
                            ))}
                            <div className="mt-1" style={{ fontSize: '13px' }}>
                              <strong>Total Allowances: ${editedPayrollData.earnings?.allowances?.total_allowances || 0}</strong>
                            </div>
                          </div>
                        )}

                        {/* Retirement Benefits */}
                        {editedPayrollData.earnings?.retirement_benefits?.retirement_benefits?.length > 0 && (
                          <div className="mb-2">
                            <label style={{ fontSize: '13px', marginBottom: '8px' }}><strong>Retirement Benefits</strong></label>
                            {editedPayrollData.earnings.retirement_benefits.retirement_benefits.map((benefit, index) => (
                              <div key={benefit.id || index} className="mb-2">
                                <div className="input-group input-group-sm">
                                  <span className="input-group-text" style={{ fontSize: '12px', padding: '4px 8px', width: 'auto', minWidth: '120px' }}>{benefit.name}</span>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={benefit.amount || 0}
                                    onChange={(e) => handleFieldChange('earnings', `retirement_${index}`, e.target.value)}
                                    step="0.01"
                                    style={{ padding: '4px 8px', fontSize: '12px' }}
                                  />
                                </div>
                              </div>
                            ))}
                            <div className="mt-1" style={{ fontSize: '13px' }}>
                              <strong>Total Retirement Benefits: ${editedPayrollData.earnings?.retirement_benefits?.total_retirement_benefits || 0}</strong>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Deductions Section */}
                      <div className="col-md-6" style={{
                        backgroundColor: '#f8d7da',
                        padding: '12px',
                        borderRadius: '6px',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 50%',
                        minWidth: 0
                      }}>
                        <h5 style={{ color: '#721c24', marginBottom: '12px', fontSize: '16px' }}>Deductions</h5>

                        {/* Taxes */}
                        {editedPayrollData.deductions?.taxes?.taxes?.length > 0 && (
                          <div className="mb-2">
                            <label style={{ fontSize: '13px', marginBottom: '8px' }}><strong>Taxes</strong></label>
                            {editedPayrollData.deductions.taxes.taxes.map((tax, index) => (
                              <div key={tax.id || index} className="mb-2">
                                <div className="input-group input-group-sm">
                                  <span className="input-group-text" style={{ fontSize: '12px', padding: '4px 8px', width: 'auto', minWidth: '120px' }}>{tax.name}</span>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={tax.amount || 0}
                                    onChange={(e) => handleFieldChange('deductions', `tax_${index}`, e.target.value)}
                                    step="0.01"
                                    style={{ padding: '4px 8px', fontSize: '12px' }}
                                  />
                                </div>
                              </div>
                            ))}
                            <div className="mt-1" style={{ fontSize: '13px' }}>
                              <strong>Total Taxes: ${editedPayrollData.deductions?.taxes?.total_taxes || 0}</strong>
                            </div>
                          </div>
                        )}

                        {/* Other Deductions */}
                        {editedPayrollData.deductions?.other_deductions?.other_deductions?.length > 0 && (
                          <div className="mb-2">
                            <label style={{ fontSize: '13px', marginBottom: '8px' }}><strong>Other Deductions</strong></label>
                            {editedPayrollData.deductions.other_deductions.other_deductions.map((deduction, index) => (
                              <div key={deduction.id || index} className="mb-2">
                                <div className="input-group input-group-sm">
                                  <span className="input-group-text" style={{ fontSize: '12px', padding: '4px 8px', width: 'auto', minWidth: '120px' }}>{deduction.name}</span>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={deduction.amount || 0}
                                    onChange={(e) => handleFieldChange('deductions', `other_deduction_${index}`, e.target.value)}
                                    step="0.01"
                                    style={{ padding: '4px 8px', fontSize: '12px' }}
                                  />
                                </div>
                              </div>
                            ))}
                            <div className="mt-1" style={{ fontSize: '13px' }}>
                              <strong>Total Other Deductions: ${editedPayrollData.deductions?.other_deductions?.total_other_deductions || 0}</strong>
                            </div>
                          </div>
                        )}

                        {/* Adjusted Deductions */}
                        {editedPayrollData.deductions?.adjusted_deduction?.adjusted_deduction?.length > 0 && (
                          <div className="mb-2">
                            <label style={{ fontSize: '13px', marginBottom: '8px' }}><strong>Adjusted Deductions</strong></label>
                            {editedPayrollData.deductions.adjusted_deduction.adjusted_deduction.map((deduction, index) => (
                              <div key={deduction.id || index} className="mb-2">
                                <div className="input-group input-group-sm">
                                  <span className="input-group-text" style={{ fontSize: '12px', padding: '4px 8px', width: 'auto', minWidth: '120px' }}>{deduction.name}</span>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={deduction.amount || 0}
                                    onChange={(e) => handleFieldChange('deductions', `adjusted_deduction_${index}`, e.target.value)}
                                    step="0.01"
                                    style={{ padding: '4px 8px', fontSize: '12px' }}
                                  />
                                </div>
                              </div>
                            ))}
                            <div className="mt-1" style={{ fontSize: '13px' }}>
                              <strong>Total Adjusted Deductions: ${editedPayrollData.deductions?.adjusted_deduction?.total_adjusted_deduction || 0}</strong>
                            </div>
                          </div>
                        )}

                        <div className="mt-2" style={{ fontSize: '13px' }}>
                          <strong>Total Deductions: ${editedPayrollData.deductions?.total_other_deductions || 0}</strong>
                        </div>
                      </div>
                    </div>

                    {/* Sources Section */}
                    {editedPayrollData.sources?.length > 0 && (
                      <div className="mb-3" style={{
                        backgroundColor: '#d1ecf1',
                        padding: '12px',
                        borderRadius: '6px',
                        marginBottom: '15px'
                      }}>
                        <h5 style={{ color: '#0c5460', marginBottom: '12px', fontSize: '16px' }}>Sources of Funds</h5>
                        <div className="row">
                          {editedPayrollData.sources.map((source, index) => (
                            <div key={source.id || index} className="col-md-6 mb-2 p-2" style={{
                              backgroundColor: 'white',
                              borderRadius: '4px',
                              border: '1px solid #bee5eb'
                            }}>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: '12px', marginBottom: '2px' }}><strong>Project Name</strong></label>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={source.project_name || ''}
                                      onChange={(e) => handleFieldChange('sources', 'project_name', e.target.value, index)}
                                      style={{ padding: '4px 8px', fontSize: '12px' }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: '12px', marginBottom: '2px' }}><strong>Budget Name</strong></label>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={source.budget_name || ''}
                                      onChange={(e) => handleFieldChange('sources', 'budget_name', e.target.value, index)}
                                      style={{ padding: '4px 8px', fontSize: '12px' }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: '12px', marginBottom: '2px' }}><strong>Budget Line</strong></label>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={source.budget_line || ''}
                                      onChange={(e) => handleFieldChange('sources', 'budget_line', e.target.value, index)}
                                      style={{ padding: '4px 8px', fontSize: '12px' }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: '12px', marginBottom: '2px' }}><strong>Percentage (%)</strong></label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={source.percentage || 0}
                                      onChange={(e) => handleFieldChange('sources', 'percentage', e.target.value, index)}
                                      step="0.01"
                                      style={{ padding: '4px 8px', fontSize: '12px' }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: '12px', marginBottom: '2px' }}><strong>Amount</strong></label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={source.amount || 0}
                                      onChange={(e) => handleFieldChange('sources', 'amount', e.target.value, index)}
                                      step="0.01"
                                      style={{ padding: '4px 8px', fontSize: '12px' }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="mt-2" style={{ fontSize: '13px' }}>
                          <strong>Total Sources: ${editedPayrollData.total_sources || 0}</strong>
                        </div>
                      </div>
                    )}

                    {/* Updated JSON Display */}
                    {showUpdatedJson && updatedDetailsJson && (
                      <div className="mb-4" style={{
                        backgroundColor: '#e7f3ff',
                        padding: '20px',
                        borderRadius: '8px',
                        marginTop: '20px',
                        border: '2px solid #0066cc'
                      }}>
                        <h4 style={{ color: '#0066cc', marginBottom: '15px' }}>
                          ✓ Updated Details (JSON)
                        </h4>
                        <div style={{
                          backgroundColor: '#f8f9fa',
                          padding: '15px',
                          borderRadius: '6px',
                          border: '1px solid #dee2e6',
                          maxHeight: '400px',
                          overflow: 'auto',
                          fontFamily: 'monospace',
                          fontSize: '12px',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word'
                        }}>
                          {updatedDetailsJson}
                        </div>
                        <button
                          onClick={() => {
                            navigator.clipboard.writeText(updatedDetailsJson).then(() => {
                              cogoToast.success("JSON copied to clipboard!", {});
                            }).catch(() => {
                              cogoToast.error("Failed to copy JSON", {});
                            });
                          }}
                          className="btn btn-sm btn-outline-primary mt-3"
                        >
                          Copy JSON
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="modal-footer" style={{
                borderTop: '1px solid #e9ecef',
                padding: '20px 30px',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '15px'
              }}>
                <button
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingPayrollItem(null);
                    setEditedPayrollData(null);
                    setUpdatedDetailsJson(null);
                    setShowUpdatedJson(false);
                  }}
                  className="btn btn-secondary"
                  style={{
                    padding: '12px 30px',
                    borderRadius: '8px',
                    fontWeight: '500',
                    fontSize: '16px'
                  }}
                >
                  {showUpdatedJson ? 'Close' : 'Cancel'}
                </button>
                <button
                  onClick={handleUpdatePayroll}
                  className="btn btn-primary"
                  disabled={isRecalculating}
                  style={{
                    padding: '12px 30px',
                    borderRadius: '8px',
                    fontWeight: '500',
                    fontSize: '16px',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}
                >
                  {isRecalculating ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                      Updating...
                    </>
                  ) : (
                    '✓ Update'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PayrollSummary;